import {Inject, Injectable, Optional} from "@angular/core";
import {AI_REALTIME_TOOL_DEFINITIONS, AiRealtimeToolDefinition} from "../../api/service/aiRealtime.service";

@Injectable({ providedIn: 'root' })
export class AiRealtimeToolDefinitionRegistry {
    private _definitions: AiRealtimeToolDefinition[];

    constructor(
        @Optional()
        @Inject(AI_REALTIME_TOOL_DEFINITIONS)
            definitionsGroups: AiRealtimeToolDefinition[][] | null
    ) {
        this._definitions = (definitionsGroups ?? []).flat();
    }

    get(toolName: string): AiRealtimeToolDefinition | undefined {
        return this._definitions.find(x => x.toolName === toolName);
    }

    getRunningLabel(toolName: string): string {
        return this.get(toolName)?.runningLabel ?? toolName;
    }

    getSuccessLabel(toolName: string): string {
        return this.get(toolName)?.successLabel ?? toolName;
    }

    getErrorLabel(toolName: string): string {
        return this.get(toolName)?.errorLabel ?? 'Erreur pendant l’exécution';
    }


    get definitions(): AiRealtimeToolDefinition[] {
        return this._definitions;
    }
}